import { combineActionMiddlewares } from "../middleware";
import { authzActionSlice } from "./authz.action";
import { loansActionSlice } from "./loans.actions";
import { reportActionSlice } from "./report.action";
import { idLookupActionSlice } from "./id-lookup.action";
import { policySimulationActionSlice } from "./policy-simulation.action";
//INFO: Middleware is by default provided through slices created using create API and is necessary to be added here for handling API requests, responses and errors
const rootActions = combineActionMiddlewares(
  reportActionSlice.middleware,
  loansActionSlice.middleware,
  authzActionSlice.middleware,
  idLookupActionSlice.middleware,
  policySimulationActionSlice.middleware,
);

export default rootActions;
